import React, { useState, useRef } from "react";
import { BartRoutes } from "src/routing/bartRoutes";
import { InitDomain } from "../context/domain/domainContext";
import { Domain } from "src/config/BartLambdaConfig";
import { configureDomain } from "src/auth/config";
import { FullPageHeader } from "src/components/header/header";
import { AuthService } from "src/auth/auth-service";
export const RouteMap = () => {
  const [domain, setDomain] = useState<Domain>(configureDomain);

  // Lazy initialization of AuthService - only create once
  const authServiceRef = useRef<AuthService | null>(null);
  const getAuthService = (): AuthService => {
    if (!authServiceRef.current) {
      authServiceRef.current = new AuthService();
    }
    return authServiceRef.current;
  };

  return (
    <InitDomain.Provider
      value={{
        domain,
        setDomain,
        authService: getAuthService(),
      }}
    >
      {/*
       * The `#b` / `#h` ids are not decorative: Cloudscape's AppLayout defaults to
       * `headerSelector="#b #h"` and measures that element's height to compute its own
       * `min-height: calc(100vh - headerHeight)`. Without a match the measured height is
       * 0, so every AppLayout claims a full viewport while sitting below the top
       * navigation, pushing the document ~56px past the viewport and making every page
       * scrollable. Keeping the header `sticky` (not `fixed`) leaves it in normal flow so
       * header height + layout height adds up to exactly 100vh.
       */}
      <div id="b">
        <div id="h" style={{ position: "sticky", top: 0, zIndex: 2000 }}>
          <FullPageHeader />
        </div>
        <BartRoutes domain={domain} />
      </div>
    </InitDomain.Provider>
  );
};
